import { Modal, Tooltip } from 'antd';

import SettingIcon from '@asset/settings.icon.svg?react';
import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text, Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { NewWebhookForm } from '@form/new-webhook/new-webhook.form';

import { useNewWebhook } from './new-webhook.hook';
import { FooterWrapper, NewWebhookButton, Wrapper } from './new-webhook.style';

export const NewWebhook = () => {
  const { form, isLoading, isModalOpen, shouldEdit, onOpenModal, onCloseModal, onFinish, error } = useNewWebhook();

  return (
    <>
      <Tooltip
        color={ColorEnum.Error100}
        placement='top'
        title={
          shouldEdit ? (
            ''
          ) : (
            <Text color={ColorEnum.Inherit} level='s'>
              You don&apos;t have permission
            </Text>
          )
        }
      >
        <NewWebhookButton
          disabled={!shouldEdit}
          icon={<SettingIcon fill={ColorEnum.Black100} width={24} />}
          type={ButtonTypeEnum.Primary}
          block
          ghost
          onClick={onOpenModal}
        >
          <Text color={ColorEnum.Black100} level='m' weight={400}>
            Create Webhook
          </Text>
        </NewWebhookButton>
      </Tooltip>
      <Modal
        confirmLoading={isLoading}
        open={isModalOpen}
        width={640}
        footer={
          <FooterWrapper>
            <Button key='back' type={ButtonTypeEnum.Primary} ghost onClick={onCloseModal}>
              Cancel
            </Button>
            <Button key='submit' type={ButtonTypeEnum.Primary} onClick={() => form.validateFields().then(onFinish)}>
              Add webhook
            </Button>
          </FooterWrapper>
        }
        title={
          <Title level={4} weight={400}>
            Create webhook
          </Title>
        }
        onCancel={onCloseModal}
        onOk={() => form.validateFields().then(onFinish)}
      >
        <Wrapper>
          <NewWebhookForm error={error} form={form} />
        </Wrapper>
      </Modal>
    </>
  );
};
